<template>
    <v-app :class="config.campagnaWeb=='S' ? '' : ''" class="sellaRegular">
      <ToolBar @scrollTo="scrollTo" :config="config" :showHome="showHome" @changeShowHome="changeShowHome"/>
          <v-content v-show="showHome">
              <v-container fluid fill-height>
                  <v-flex xs12 sm10 offset-sm1 md6 offset-md3 lg6 offset-lg3>


                      <Prodotto ref="home" @scrollTo="scrollTo" :config="config"/>

                      <v-layout row wrap py-3>
                          <v-flex xs12 sm10 offset-sm1>
                              <v-divider :class="config.campagnaWeb=='S' ? 'bFDividerColor' : ''"></v-divider>
                          </v-flex>
                      </v-layout>

                      <v-layout row wrap ref="prodotto" pt-4>
                          <v-flex xs12>
                              <div>
                                  <strong :class="config.campagnaWeb=='S' ? 'bFTitleColor--text display-3 font-weight-bold sellaStencil' : 'primary--text display-3 font-weight-bold sellaStencil'">Il Prodotto</strong>
                              </div>
                              <p :class="config.campagnaWeb=='S' ? 'bFTextColor--text sellaRegular' : 'sellaRegular'">
                                  ProntoTuo è il prestito personale di Sella Personal Credit che ti permette di realizzare
                                  i
                                  tuoi desideri ovunque tu sia.<br>
                                  Puoi richiedere da 2.000€ a 60.000€ con durate da 12 a 120 mesi; ricevi quanto ti serve
                                  in
                                  poche ore e rimborsi in rate mensili dell’importo che desideri.
                                  <br>
                                  Per iniziare la richiesta sono sufficienti un documenti d'identità, codice fiscale e
                                  documento di reddito e...niente carta!<br>
                                  ProntoTuo è infatti 100% "green" con la firma digitale, un particolare tipo di firma
                                  elettronica valida a tutti gli effetti di legge. Sarà tutto semplice: dovrai solo
                                  inserire
                                  il codice riservato (OTP) che riceverai sul tuo smartphone.


                              </p>

                          </v-flex>
                          <v-flex xs12 sm10 offset-sm1>
                              <v-divider :class="config.campagnaWeb=='S' ? 'bFDividerColor' : ''"></v-divider>
                          </v-flex>
                      </v-layout>

                      <Preventivatore ref="rata" :config="config"/>

                      <v-layout>
                          <v-flex xs12 sm10 offset-sm1 mt-4>
                              <v-divider :class="config.campagnaWeb=='S' ? 'bFDividerColor' : ''"></v-divider>
                          </v-flex>
                      </v-layout>

                      <Opinions ref="opinions" :config="config"/>

                      <v-layout mt-5>
                          <v-flex xs12 sm10 offset-sm1>
                              <v-divider :class="config.campagnaWeb=='S' ? 'bFDividerColor' : ''"></v-divider>
                          </v-flex>
                      </v-layout>

                      <v-layout align-center justify-center row fill-height mt-4>
                          <v-flex md6 xs12>
  <!--                            <v-img src="../img/sigilli_prontotuo.png" aspect-ratio="4.42"/>-->
                          </v-flex>
                      </v-layout>

                      <v-layout justify-center mt-3>
                          <p class="primary--text headline text-xs-center"
                             :class="config.campagnaWeb=='S' ? 'bFTextColor--text headline text-xs-center' : 'primary--text headline text-xs-center'">Sella Personal Credit fa parte del
                              Gruppo Sella:<br> esperienza e affidabilità dal 1886.</p>
                      </v-layout>

                      <v-layout>
                          <v-flex xs12 sm10 offset-sm1>

                          </v-flex>
                      </v-layout>


                      <v-layout row wrap>
                          <v-flex xs12 class="mb-1">
                              <p flat style="font-size: 10px" :class="config.campagnaWeb=='S' ? 'bFTextColor--text ' : 'theme--light'">
                                  <v-icon :color="config.campagnaWeb=='S' ? 'bFTextColor' : ''" left>short_text</v-icon>
                                  LIMITI E IMPORTI: <br>
                                  <v-divider></v-divider>
                                  {{config.limitiImporti}}
                              </p>
                          </v-flex>
                      </v-layout>
                      <v-layout row wrap>
                          <v-flex xs12 class="mb-1 mt-1">
                              <p flat style="font-size: 10px" :class="config.campagnaWeb=='S' ? 'bFTextColor--text ' : 'theme--light'">
                                  <v-icon :color="config.campagnaWeb=='S' ? 'bFTextColor' : ''" left>short_text</v-icon>
                                  TERMINI E CONDIZIONI: <br>
                                  <v-divider></v-divider>
                                  {{config.terminiCondizioni}}
                              </p>
                          </v-flex>
                      </v-layout>
                  </v-flex>
              </v-container>
          </v-content>

          <v-content v-show="showPrivacy">
            <Privacy :config="config" ref="privacy"/>
          </v-content>

        <v-footer style="min-height: 200px">
            <v-container fluid class="pa-0 m-a0">

                <v-layout row wrap>
                    <v-flex xs12 class="secondary white--text text-xs-center">
                        <v-btn flat round>
                            <a style="color:white; text-decoration:none;"
                               href="https://www.sellapersonalcredit.it/public/content/generic/chisiamo">CHI SIAMO </a>
                        </v-btn>
                        <v-btn flat round>
                            <a style="color:white; text-decoration:none;"
                               href="https://www.sellapersonalcredit.it/public/content/generic/contatti">CONTATTI </a>
                        </v-btn>
                        <v-btn flat round>
                            <a style="color:white; text-decoration:none;"
                               href="https://www.sellapersonalcredit.it/public/content/generic/glossario">GLOSSARIO </a>
                        </v-btn>
                        <v-btn flat round>
                            <a style="color:white; text-decoration:none;"
                               href="https://www.sellapersonalcredit.it/public/content/generic/faq">DOMANDE
                                FREQUENTI </a>
                        </v-btn>
                        <v-btn flat round>
                            <a style="color:white; text-decoration:none;"
                               href="https://www.sellapersonalcredit.it/public/content/generic/trasparenza">TRASPARENZA</a>
                        </v-btn>
                        <v-btn flat round>
                            <a style="color:white; text-decoration:none;"
                               @click="changeShowPrivacy">PRIVACY </a>
                        </v-btn>
                    </v-flex>
                    
                    <v-flex xs12>
                        <v-card color="primary" flat>
                            <v-layout align-center justify-center row wrap py-3 px-2>
                                <v-flex xs12 md4 justify-center>
                                    <v-layout row wrap>
                                        <v-flex sm6 class="hidden-sm-and-down"></v-flex>
                                        <v-flex xs4 class="hidden-sm-and-up"></v-flex>
                                        <v-flex sm6 xs6 justify-end>
                                            <v-img src="../img/SPC_white.png" max-width="135"
                                                   aspect-ratio="2.68"></v-img>

                                        </v-flex>

                                    </v-layout>
                                </v-flex>
                                <v-flex md4 xs12 class="pa-2">
                                    <span class="white--text justify sellaRegular">
                                        Sella Personal Credit SpA <br>
                                        Società soggetta all'attività di direzione e coordinamento della Banca Sella Holding SpA <br>
                                        Via V. Bellini 2 - 10121 Torino <br>
                                        PEC: sellapersonalcredit@actaliscertymail.it <br>
                                        Società appartenente al Gruppo Iva Maurizio Sella S.A.A. con P. IVA 02675650028 Cod.Fisc. / Num.
                                        iscrizione presso l’Ufficio del Registro di Torino 02007340025 R.E.A. n. 948365 <br>
                                        Capitale sociale e riserve: 99.149.557,25 euro
                                    </span>
                                </v-flex>
                                <v-flex xs12 md4>
                                    <v-layout :justify-start="$vuetify.breakpoint.mdAndUp"
                                              :justify-center="!$vuetify.breakpoint.mdAndUp" row fill-height
                                              class="pr-3">
                                        <v-img style="cursor:pointer"
                                               @click="openUrl('https://www.facebook.com/SellaPersonalCredit/')"
                                               src="../img/fb_icon.png" max-width=45 max-height=70></v-img>
                                        <v-img style="cursor:pointer"
                                               @click="openUrl('https://twitter.com/SellaPersonalCr')"
                                               src="../img/twitter_icon.png" max-width=45 max-height=70></v-img>
                                        <v-img style="cursor:pointer"
                                               @click="openUrl('https://www.linkedin.com/company/1196660')"
                                               src="../img/linkedin_icon.png" max-width=45 max-height=70></v-img>
                                        <v-img style="cursor:pointer"
                                               @click="openUrl('https://www.youtube.com/channel/UCyPox7M1n_YXRIfoAzTy0kw')"
                                               src="../img/youtube_icon.png" max-width=45 max-height=70></v-img>
                                    </v-layout>
                                </v-flex>
                            </v-layout>

                        </v-card>

                    </v-flex>

                </v-layout>
            </v-container>
        </v-footer>

    </v-app>
</template>

<script>
    import Preventivatore from './components/Preventivatore'
    import ToolBar from "./components/ToolBar"
    import Privacy from "./components/Privacy"
    import Prodotto from "./components/Prodotto"
    import Opinions from "./components/Opinions"
    import axios from 'axios';


    export default {
        name: "App",
        components: {
            Preventivatore,
            ToolBar,
            Privacy,
            Prodotto,
            Opinions
        },
        data() {
            return {
                rate: [],
                config: [],
                error: null,
                ready: false,
                condition: false,
                limits: false,
                showHome: true,
                showPrivacy: false
            };
        },
        mounted() {
            this.getConfigParams();
        },
        methods: {
            scrollTo(name) {
                this.$vuetify.goTo(this.$refs[name])
            },
            openUrl(url) {
                window.location.href = url;
            },
            getConfigParams() {
                let currentObj = this;
                axios.get('get-configuration', {
                }).then((response) => {
                    currentObj.config = response.data;
                    currentObj.ready = true;
                }).catch(function (error) {
                    currentObj.error = error;
                });
            },
            changeShowPrivacy() {
                this.showHome = false;
                this.showPrivacy = true;
                this.scrollTo('privacy');
            },
            changeShowHome() {
                this.showHome = true;
                this.showPrivacy = false;
            }
        }
    };
</script>

<style scoped>

    .bFBackground{
        height: 900px;
        background-color: #000000;
        background-image: linear-gradient(#000000, #ffffff);
    }

    @font-face {
        font-family: 'Sella';
        src: url('assets/fonts/Sella-Regular.woff2') format('woff2'),
        url('assets/fonts/Sella-Regular.woff') format('woff');
        font-weight: normal;
        font-style: normal;
    }

    @font-face {
        font-family: 'Sella Stencil';
        src: url('assets/fonts/SellaStencil-Regular.woff2') format('woff2'),
        url('assets/fonts/SellaStencil-Regular.woff') format('woff');
        font-weight: normal;
        font-style: normal;
    }

    @font-face {
        font-family: 'Sella Bold';
        src: url('assets/fonts/Sella-Bold.woff2') format('woff2'),
        url('assets/fonts/Sella-Bold.woff') format('woff');
        font-weight: bold;
        font-style: normal;
    }

    @font-face {
        font-family: 'Sella Stencil';
        src: url('assets/fonts/SellaStencil-Bold.woff2') format('woff2'),
        url('assets/fonts/SellaStencil-Bold.woff') format('woff');
        font-weight: bold;
        font-style: normal;
    }

    @font-face {
        font-family: 'Sella Stencil';
        src: url('assets/fonts/SellaStencil-Medium.woff2') format('woff2'),
        url('assets/fonts/SellaStencil-Medium.woff') format('woff');
        font-weight: 500;
        font-style: normal;
    }

    @font-face {
        font-family: 'Sella';
        src: url('assets/fonts/Sella-Medium.woff2') format('woff2'),
        url('assets/fonts/Sella-Medium.woff') format('woff');
        font-weight: 500;
        font-style: normal;
    }

    .sellaRegular {
        font-family: 'Sella' !important;
    }

    .sellaStencil {
        font-family: 'Sella Stencil' !important;
    }

    .sellaBold {
        font-family: 'Sella Bold' !important;
    }
</style>

